import { render, staticRenderFns } from "./personalProfile.vue?vue&type=template&id=2b698c62"
import script from "./personalProfile.vue?vue&type=script&lang=js"
export * from "./personalProfile.vue?vue&type=script&lang=js"
import style0 from "./personalProfile.vue?vue&type=style&index=0&id=2b698c62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports